// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "../../../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Caml_option from "../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as ReactModal from "react-modal";
import * as CountryContext from "../../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CrmRepoManager from "../../../../../../to-be-migrated/domain/repo/CrmRepoManager.bs.js";
import * as Button$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as FormInput$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as ModalFooter$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/modal/ModalFooter.bs.js";
import * as ModalStyles$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/modal/ModalStyles.bs.js";
import * as FormTitleBar$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormTitleBar.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as PrimitiveFormTypes$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/PrimitiveFormTypes.bs.js";
import * as LoadingViewComponent$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/LoadingViewComponent.bs.js";
import * as SuccessInfoComponent$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/success/SuccessInfoComponent.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

var validators = {
  comment: {
    strategy: /* OnSubmit */4,
    validate: (function (param) {
        return PrimitiveFormTypes$Catalyst.getValue({
                    TAG: /* String */1,
                    _0: param.comment
                  });
      })
  }
};

function initialFieldsStatuses(_input) {
  return {
          comment: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            comment: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.comment;
  var match$1 = match ? match._0 : Curry._1(validators.comment.validate, input);
  if (match$1.TAG === /* Ok */0) {
    return {
            TAG: /* Valid */0,
            output: {
              comment: match$1._0
            },
            fieldsStatuses: {
              comment: /* Dirty */{
                _0: match$1,
                _1: /* Shown */0
              }
            },
            collectionsStatuses: undefined
          };
  } else {
    return {
            TAG: /* Invalid */1,
            fieldsStatuses: {
              comment: /* Dirty */{
                _0: match$1,
                _1: /* Shown */0
              }
            },
            collectionsStatuses: undefined
          };
  }
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurCommentField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.comment, validators.comment, (function (status) {
                          return {
                                  comment: status
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */1 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */1,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */2,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */4);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */3);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */2 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */3 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */4 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateCommentField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.comment, state.submissionStatus, validators.comment, (function (status) {
                                    return {
                                            comment: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */1 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                comment: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                comment: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */2 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */3 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateComment: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateCommentField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurComment: (function (param) {
              return Curry._1(dispatch, /* BlurCommentField */0);
            }),
          commentResult: Formality.exposeFieldResult(state.fieldsStatuses.comment),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.comment) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */1);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */2);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */3);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */3,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */4);
            })
        };
}

var UnSuspendForm = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function getErrorSection(error) {
  if (error !== undefined) {
    return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                error: error
              });
  } else {
    return null;
  }
}

function UnsuspendModal(Props) {
  var msisdn = Props.msisdn;
  var onToggle = Props.onToggle;
  var openSnackbar = Props.openSnackbar;
  var refreshView = Props.refreshView;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useReducer((function (_state, action) {
          if (action.TAG === /* OnSuccess */0) {
            var data = action._0;
            Curry._1(openSnackbar, {
                  TAG: /* Success */0,
                  _0: data.message
                });
            Curry._1(refreshView, undefined);
            Curry._1(onToggle, undefined);
            return {
                    requestStatus: {
                      TAG: /* Live */1,
                      _0: data
                    }
                  };
          }
          Curry._1(refreshView, undefined);
          Curry._1(onToggle, undefined);
          return {
                  requestStatus: {
                    TAG: /* Error */2,
                    _0: action._0
                  }
                };
        }), {
        requestStatus: /* Init */0
      });
  var dispatch = match$1[1];
  var form = useForm({
        comment: ""
      }, (function (output, submissionCbs) {
          var RepoInstance = CrmRepoManager.getSuspensionRepo(undefined);
          return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                        return Curry._3(RepoInstance.unsuspendPartner, msisdn, output.comment, country);
                      }), (function (data) {
                        Curry._1(submissionCbs.notifyOnSuccess, undefined);
                        return Curry._1(dispatch, {
                                    TAG: /* OnSuccess */0,
                                    _0: data
                                  });
                      }), (function (error) {
                        return Curry._1(dispatch, {
                                    TAG: /* OnError */1,
                                    _0: error
                                  });
                      }));
        }));
  var _data = match$1[0].requestStatus;
  var tmp;
  if (typeof _data === "number") {
    tmp = React.createElement(React.Fragment, undefined, React.createElement(FormTitleBar$Catalyst.make, {
              title: "Unsuspend Driver",
              onCloseCb: onToggle
            }), React.createElement("form", {
              className: "suspension-form",
              onSubmit: (function ($$event) {
                  $$event.preventDefault();
                  
                })
            }, React.createElement("div", {
                  className: "suspension-form__section"
                }, React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("Comments", (function ($$event) {
                              return Curry._2(form.updateComment, (function (_input, value) {
                                            return {
                                                    comment: value
                                                  };
                                          }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                            }), undefined, undefined, undefined, undefined, undefined, undefined, form.commentResult, undefined, "max-width comment-input", true, undefined, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: form.input.comment
                      }
                    })), React.createElement("div", {
                  className: "submit"
                }, React.createElement(Button$Catalyst.make, {
                      text: "Unsuspend",
                      cb: (function (param) {
                          return Curry._1(form.submit, undefined);
                        }),
                      className: "btn-primary submit-button",
                      disabled: form.input.comment.trim().length === 0
                    }))));
  } else {
    switch (_data.TAG | 0) {
      case /* Loading */0 :
          tmp = React.createElement(React.Fragment, undefined, React.createElement(FormTitleBar$Catalyst.make, {
                    title: "Unsuspend Driver",
                    onCloseCb: (function (param) {
                        
                      })
                  }), React.createElement(LoadingViewComponent$Catalyst.make, {}));
          break;
      case /* Live */1 :
          tmp = React.createElement(React.Fragment, undefined, React.createElement(FormTitleBar$Catalyst.make, {
                    title: "Unsuspend Driver",
                    onCloseCb: (function (param) {
                        Curry._1(refreshView, undefined);
                        return Curry._1(onToggle, undefined);
                      })
                  }), React.createElement("div", undefined, React.createElement(SuccessInfoComponent$Catalyst.make, {
                        message: _data._0.message
                      }), React.createElement(ModalFooter$Catalyst.make, {
                        label: "Close",
                        cb: (function (param) {
                            Curry._1(refreshView, undefined);
                            return Curry._1(onToggle, undefined);
                          })
                      })));
          break;
      case /* Error */2 :
          tmp = React.createElement(React.Fragment, undefined, React.createElement(FormTitleBar$Catalyst.make, {
                    title: "Unsuspend Driver",
                    onCloseCb: onToggle
                  }), React.createElement("div", undefined, React.createElement(ErrorDisplayComponent$Catalyst.make, {
                        error: _data._0
                      }), React.createElement(ModalFooter$Catalyst.make, {
                        label: "Close",
                        cb: (function (param) {
                            Curry._1(refreshView, undefined);
                            return Curry._1(onToggle, undefined);
                          })
                      })));
          break;
      
    }
  }
  return React.createElement(ReactModal, {
              isOpen: true,
              onRequestClose: (function (param) {
                  return Curry._1(onToggle, undefined);
                }),
              style: ModalStyles$Catalyst.getAlignContentCenterStyle("50rem", undefined),
              className: "c-suspension-modal c-unsuspension-modal",
              ariaHideApp: false,
              shouldCloseOnOverlayClick: false,
              children: tmp
            });
}

var make = UnsuspendModal;

export {
  UnSuspendForm ,
  getErrorSection ,
  make ,
  
}
/* react Not a pure module */
